/**
 * La forme de la boutique de gestes pendant son premier chargement : la carte « Tes crédits »,
 * dont l'intitulé ne dépend d'aucune donnée, puis les deux gestes, dans les colonnes de la page.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { columnStyles } from "../../atoms/containers/columns"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Text } from "../../atoms/typography/Text"
import { Card } from "../../molecules/Card"
import { GAME_GLYPH_SIZE } from "../../molecules/GameGlyph"
import { ShopGestureCardSkeleton } from "../../organisms/ShopGestureCard"
import { SHOP_TEXTS } from "./shopTexts"

export function StudentShopSkeleton() {
    return (
        <View style={[columnStyles.columns, styles.fullWidth]}>
            <Stack gap="4" style={columnStyles.column}>
                <Card p="4">
                    <Row gap="3" justify="between">
                        <Text size="text-lg" weight="bold">
                            {SHOP_TEXTS.balance}
                        </Text>
                        <Row gap="2">
                            <Skeleton shape="circle" size={GAME_GLYPH_SIZE.row} />
                            <Skeleton textSize="text-lg" width={40} />
                        </Row>
                    </Row>
                </Card>
            </Stack>
            <Stack gap="4" style={columnStyles.column}>
                <ShopGestureCardSkeleton />
                <ShopGestureCardSkeleton />
            </Stack>
        </View>
    )
}

const styles = StyleSheet.create(() => ({
    fullWidth: { width: "100%" },
}))
